var React = require('react');

function MobileCenterLogo (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M1.45 4.17l6-4L9 1v4.34l4.42-3.15L15 3v10l-1.58.82L9 10.66V15l-1.55.83-6-4v-1.66L4.7 8 1.45 5.83V4.17zm2.35.86L7 7.16V2.9L3.8 5.03zm4.92 3L12 10.37V5.7L8.72 8.02zM7 8.9l-3.2 2.13L7 13.16V8.9z","fillRule":"nonzero"}));
}

MobileCenterLogo.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16"};

module.exports = MobileCenterLogo;

MobileCenterLogo.default = MobileCenterLogo;
